
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { VuetifyMixin, MindsetMixin } from '@/mixins';
import MindsetInformation from '@/components/mindset/MindsetInformation.vue'
import RyzerAthleteTypeCard from '@/components/mindset/RyzerAthleteTypeCard.vue';
import RyzerScore from "@/components/ui/RyzerScore.vue";

@Component({
	components: { 
		MindsetInformation,
		RyzerAthleteTypeCard,
		RyzerScore,
	 },
})
export default class CoachMindsetReportCard extends Mixins(VuetifyMixin, MindsetMixin) {
	@Prop({ type: Boolean }) loading: boolean;
	@Prop({ type: Boolean }) flat;
	@Prop({ type: Boolean }) basic;
	@Prop({ type: Boolean }) stats;
	@Prop({ type: String, default: '20'}) size;
}
